import { render } from "./GovernmentMaster.vue?vue&type=template&id=47a866be&scoped=true"
import script from "./GovernmentMaster.vue?vue&type=script&lang=js"
export * from "./GovernmentMaster.vue?vue&type=script&lang=js"

import "./GovernmentMaster.vue?vue&type=style&index=0&id=47a866be&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\CMRF\\cmrf_admin_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47a866be"]])

export default __exports__